module.exports = __webpack_public_path__ + "img/02.4f8d3128.jpg";